import React, { memo } from "react";

import styles from "./styles.module.scss";

const SiderBottomInfo = ({ children }: any) => {
	return (
		<div className={styles.siderBottomInfo}>
			<div className={styles.title}>
				{"This UHub is powered by "}
				<a
					href="https://ugenie.io"
					target="_blank"
					className={styles.logo}
					rel="noopener noreferrer"
				>
					{"Ugenie"}
				</a>
			</div>
		</div>
	);
};

export default memo(SiderBottomInfo);
